import { render } from "./LogoutForm.vue?vue&type=template&id=f8eab394&scoped=true"
import script from "./LogoutForm.vue?vue&type=script&lang=js"
export * from "./LogoutForm.vue?vue&type=script&lang=js"

import "./LogoutForm.vue?vue&type=style&index=0&id=f8eab394&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2236819739/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8eab394"]])

export default __exports__